import { ServiceLanguage, Tenant } from "albertine-shared-web";
import { z } from "zod";

const bookingSearchBaseSchema = z.object({
    tenant: Tenant,
    locale: ServiceLanguage,
    parentOrigin: z.url().optional(),
    mode: z.literal("agent-preview").optional(),
});

export const bookingSearchSchema = z.union([
    bookingSearchBaseSchema.extend({ id: z.string().min(1) }),
    bookingSearchBaseSchema.extend({ shareId: z.string().min(1) }),
]);

export type BookingSearch = z.infer<typeof bookingSearchSchema>;

export function isPublicShareSearch(
    search: BookingSearch,
): search is Extract<BookingSearch, { shareId: string }> {
    return "shareId" in search;
}

export function isAgentPreviewSearch(
    search: BookingSearch,
): search is Extract<BookingSearch, { id: string }> {
    return "id" in search && search.mode === "agent-preview";
}
